import { useRef } from 'react';

import { Timer } from '@dreryk/react-components';

type VisitTimerProps = {
   readonly beginDate: Date;
   readonly plannedBeginDate: Date;
   readonly plannedEndDate: Date;
};

export const VisitTimer = (props: VisitTimerProps): JSX.Element => {
   const { current: timeInMs } = useRef(
      new Date(props.plannedEndDate).getTime() - new Date(props.plannedBeginDate).getTime()
   );
   const { current: initialRemainingTimeInMs } = useRef(timeInMs - (Date.now() - new Date(props.beginDate).getTime()));

   return <Timer testId={'timer'} initialRemainingTimeInMs={initialRemainingTimeInMs} timeInMs={timeInMs} />;
};
